module.exports = __webpack_public_path__ + "static/media/Simipour_gaussian2.68fa483f.png";